import { Lecture } from "../../types/lecture";
import { LectureServiceInterface } from "./LectureServiceInterface";
export class LectureServiceLocal extends LectureServiceInterface {
    lectures = new Map();
    async getAll() {
        return Array.from(this.lectures.values()).sort((a, b) => a.lectureDate.getTime() - b.lectureDate.getTime());
    }
    async getByClassId(classroomId) {
        return Array.from(this.lectures.values())
            .filter((lecture) => lecture.classroomId === classroomId)
            .sort((a, b) => a.lectureDate.getTime() - b.lectureDate.getTime());
    }
    async getLecture(lectureId) {
        const lecture = this.lectures.get(lectureId);
        if (!lecture) {
            throw new Error(`Lecture with id ${lectureId} not found`);
        }
        return lecture;
    }
    async createLecture(lectureData) {
        const newLecture = new Lecture(lectureData);
        this.lectures.set(newLecture.id, newLecture);
        return newLecture;
    }
    async startLecture(lectureId, teacherId) {
        const lecture = await this.getLecture(lectureId);
        lecture.start(teacherId);
        this.lectures.set(lectureId, lecture);
        return lecture;
    }
    async completeLecture(lectureId) {
        const lecture = await this.getLecture(lectureId);
        lecture.complete();
        this.lectures.set(lectureId, lecture);
        return lecture;
    }
    async setAttendanceRecords(lectureId, records) {
        const lecture = await this.getLecture(lectureId);
        lecture.setAttendanceRecords(records);
        this.lectures.set(lectureId, lecture);
        return lecture;
    }
    async updateLecture(lectureId, lectureData) {
        const lecture = await this.getLecture(lectureId);
        // Only allow updating specific fields
        const updatableData = {
            classroomId: lectureData.classroomId ?? lecture.classroomId,
            topicIds: lectureData.topicIds ?? lecture.topicIds,
            weekNumber: lectureData.weekNumber ?? lecture.weekNumber,
            lectureDate: lectureData.lectureDate ?? lecture.lectureDate,
            lectureEndDate: lectureData.lectureEndDate ?? lecture.lectureEndDate,
        };
        lecture.update(updatableData);
        this.lectures.set(lectureId, lecture);
        return lecture;
    }
    async setTournamentId(lectureId, tournamentId) {
        const lecture = await this.getLecture(lectureId);
        lecture.tournamentId = tournamentId;
        this.lectures.set(lectureId, lecture);
    }
}
